document.addEventListener('alpine:init', () => {
  Alpine.data('accordionItem', () => ({
    open: false,
    toggle() {
      this.open = !this.open;
      if (this.open) {
        this.$nextTick(() => {
          this.$dispatch('accordion:open', { id: this.$id('accordion') });
        });
      }
    },
    close() { this.open = false },
    init() {
      this.open = false;
    }
  }));
});
